import './counter';



// WEBPACK FOOTER //
// ./scripts/utils/scrollmagic/scenes/counter/index.js